/**
 * Auto Refresh Plus | Page Monitor
 *
 * Exposes its content script and stylesheet to every origin.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 9.1.5.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'hgeljhfekpckiiplhkigfehkdpldcggm';
export const autoRefreshPlus: ExtensionDefinition = {
  id: ID,
  name: "Auto Refresh Plus | Page Monitor",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Exposes its content script and stylesheet to every origin.",
  signals: [
    { id: 'war-content-scripts-arp-js', kind: 'web-accessible-resource',
      description: 'Fetch content-scripts/arp.js, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'content-scripts/arp.js') },
    { id: 'war-content-scripts-script-css', kind: 'web-accessible-resource',
      description: 'Fetch content-scripts/script.css, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'content-scripts/script.css') },
  ],
};
